import getConfig from 'config/public';
import { withG2BrandSegment } from 'shared-utils/g2Workspace';

const RESEARCH_BOARD_PRODUCT_PARAM = 'research_board_product_canonical_id';
const RESEARCH_BOARD_LANDING_PATH = /\/landing\/?$/;

export const getResearchBoardSignInCallbackUrl = (productCanonicalId) => {
  const callbackUrl = new URL(window.location.href);
  callbackUrl.searchParams.set(
    RESEARCH_BOARD_PRODUCT_PARAM,
    productCanonicalId
  );

  return callbackUrl.toString();
};

export const consumeResearchBoardPickerIntent = (productCanonicalId) => {
  const callbackUrl = new URL(window.location.href);
  if (
    callbackUrl.searchParams.get(RESEARCH_BOARD_PRODUCT_PARAM) !==
    productCanonicalId
  ) {
    return false;
  }

  callbackUrl.searchParams.delete(RESEARCH_BOARD_PRODUCT_PARAM);
  window.history.replaceState(
    window.history.state,
    '',
    `${callbackUrl.pathname}${callbackUrl.search}${callbackUrl.hash}`
  );

  return true;
};

// The landing path (e.g. /assistant/landing) stays configurable, but the host
// comes from userWorkspace.url -- the same environment-aware config the
// profile menu's account links (Reviews, Rewards, Saved Products, ...) use --
// so this link points at the G2 host matching the environment GetApp is
// actually deployed in, not always prod. getG2EndpointBase() (services/auth)
// is not usable here: it reads server-only env vars that are never inlined
// into the client bundle, so calling it from this browser-side helper would
// silently always resolve to its production default.
export const getResearchBoardUrl = (boardId) => {
  const configuredLandingPath = new URL(getConfig().researchBoard.landingUrl)
    .pathname;
  const { origin } = new URL(getConfig().userWorkspace.url);
  const url = new URL(origin);
  url.pathname = configuredLandingPath.replace(
    RESEARCH_BOARD_LANDING_PATH,
    `/${boardId}`
  );

  return withG2BrandSegment(url.toString(), 'getapp');
};
